<template>
  <div class="flex flex-col sm:flex-row flex-wrap w-full sm:w-1/2 py-4">
    <div v-for="(skill, index) in listSkills" :key="index"
      class="w-full sm:w-1/2 px-8 py-4 fhd:p-16 text-center sm:text-left
      flex flex-col items-center sm:items-start">
      <component class="w-10 text-summer-red opacity-30 4k:w-20" :is="skill.icon"></component>
      <h1 class="font-semibold text-xl text-summer-red fhd:text-3xl 4k:text-5xl">
        {{skill.title}}
      </h1>
      <p class="fhd:text-xl 4k:text-3xl dark:text-gray-400">{{skill.description}}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listSkills: [
        {
          title: this.$options.filters.lang('skills', 'experience').agileTitle,
          description: this.$options.filters.lang('skills', 'experience').agileDesc,
          icon: 'IconScrum',
        },
        {
          title: this.$options.filters.lang('skills', 'experience').teamTitle,
          description: this.$options.filters.lang('skills', 'experience').teamDesc,
          icon: 'IconUsers',
        },
        {
          title: this.$options.filters.lang('skills', 'experience').designTitle,
          description: this.$options.filters.lang('skills', 'experience').designDesc,
          icon: 'IconDesing',
        },
        {
          title: this.$options.filters.lang('skills', 'experience').practiceTitle,
          description: this.$options.filters.lang('skills', 'experience').practiceDesc,
          icon: 'IconDoc',
        },
      ]
    }
  }
}
</script>